import { render, staticRenderFns } from "./ContentTitle.vue?vue&type=template&id=1079043e&scoped=true&"
import script from "./ContentTitle.vue?vue&type=script&lang=js&"
export * from "./ContentTitle.vue?vue&type=script&lang=js&"
import style0 from "./ContentTitle.vue?vue&type=style&index=0&id=1079043e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079043e",
  null
  
)

export default component.exports